var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 8.95866C10.3465 8.95866 10.6263 9.23848 10.6263 9.58366V13.7503C10.6263 14.0955 10.3465 14.3753 10.0013 14.3753C9.65612 14.3753 9.3763 14.0955 9.3763 13.7503V9.58366C9.3763 9.23848 9.65612 8.95866 10.0013 8.95866Z",
    fill: "#EE8300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4277 5.78484C10.6843 6.01575 10.7051 6.41093 10.4742 6.6675L10.4659 6.67676C10.2349 6.93333 9.83977 6.95413 9.5832 6.72322C9.32663 6.49231 9.30583 6.09712 9.53674 5.84056L9.54508 5.8313C9.77599 5.57473 10.1712 5.55393 10.4277 5.78484Z",
    fill: "#EE8300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 2.29199C5.74411 2.29199 2.29297 5.74313 2.29297 10.0003C2.29297 14.2575 5.74411 17.7087 10.0013 17.7087C14.2585 17.7087 17.7096 14.2575 17.7096 10.0003C17.7096 5.74313 14.2585 2.29199 10.0013 2.29199ZM1.04297 10.0003C1.04297 5.05277 5.05375 1.04199 10.0013 1.04199C14.9489 1.04199 18.9596 5.05277 18.9596 10.0003C18.9596 14.9479 14.9489 18.9587 10.0013 18.9587C5.05375 18.9587 1.04297 14.9479 1.04297 10.0003Z",
    fill: "#EE8300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningInfoCircle);
export default __webpack_public_path__ + "static/media/warning_info_circle.f1daa99f220b9ebfff5de6fc5c2928cd.svg";
export { ForwardRef as ReactComponent };